<template>
    <el-container direction="vertical" class="card company-card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка компании
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </span>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start" class="card-general">
                <el-row class="mb25">
                    <el-col :span="24" class="bold fnt-mid2">
                        {{ company.name }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="5">
                        <span class="bold">
                            Телефон:
                        </span>
                    </el-col>
                    <el-col :span="19">
                        <span-mask :value="company.phone" mask="+# (###) ###-##-##" />
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="5">
                        <span class="bold">
                            E-mail:
                        </span>
                    </el-col>
                    <el-col :span="19">
                        {{ company.email }}
                    </el-col>
                </el-row>
                <el-row class="mb25">
                    <el-col :span="5">
                        <span class="bold">
                            Адрес:
                        </span>
                    </el-col>
                    <el-col :span="19">
                        {{ company.address }}
                    </el-col>
                </el-row>
                <template v-if="company.contacts && company.contacts.length">
                    <el-row v-for="contact in company.contacts" :key="contact.id" class="mb25">
                        <el-col :span="5">
                            <span class="bold">
                                Контакт:
                            </span>
                        </el-col>
                        <el-col :span="19">
                            <el-row class="mb10">
                                <el-col :span="22">
                                    {{ contact.name }}
                                </el-col>
                                <el-col :span="2">
                                    <div class="cell-icon" @click="goContact(contact.id)">
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row class="mb10">
                                <el-col :span="4" class="bold mr8">
                                    Телефон:
                                </el-col>
                                <el-col :span="14">
                                    <span-mask :value="contact.phone" mask="+# (###) ###-##-##" />
                                </el-col>
                            </el-row>
                            <el-row class="mb10">
                                <el-col :span="4" class="bold mr8">
                                    Email:
                                </el-col>
                                <el-col :span="14">
                                    {{ contact.email }}
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </template>
                <el-row class="mb25">
                    <el-col :span="19" :offset="5">
                        <el-button class="spreadsheet-header-button" type="warning" @click="goContactNew">
                            новый контакт
                        </el-button>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="16" class="card-comment">
                <span class="bold">
                    Комментарий:
                </span>
                <div v-format-text="company.comment"></div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import VueTheMaskSpan from '@/components/vue-the-mask/src/component';
import '@/assets/styles/card.scss';

library.add(faCheck);

export default {
    name: 'CompaniesCard',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            company: {}
        };
    },
    components: {
        spanMask: VueTheMaskSpan
    },
    beforeMount() {
        this.getCompany();
    },
    computed: {
        canEdit() {
            const approvedRoles = this.$store.getters['references/rolesBySectionCompanies'];
            if (approvedRoles.indexOf('companies_read') !== -1) {
                approvedRoles.splice(approvedRoles.indexOf('companies_read'), 1);
            }
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));
            return intersection.length > 0;
        }
    },
    methods: {
        async getCompany() {
            this.loading = true;
            try {
                const response = await this.$store.dispatch('companies/getCompany', this.id);
                this.company = response.data.data;
                this.loading = false;
            } catch (error) {
                if (error.response.status !== 422) {
                    console.log(error.response.data.error);
                    this.loading = false;
                    this.$router.push({ name: 'companies' });
                }
            } finally {
                this.loading = false;
            }
        },
        edit() {
            if (this.canEdit) {
                this.$router.push({ name: 'company-card-edit', params: { id: '' + this.id } });
            }
        },
        close() {
            this.$router.push({ name: 'companies' });
        },
        goContactNew() {
            if (this.canEdit) {
                this.$router.push({ name: 'contact-card-new', params: { companyId: '' + this.id } });
            }
        },
        goContact(id) {
            if (this.canEdit) {
                this.$router.push({ name: 'contact-card', params: { id: '' + id } });
            }
        }
    }
};
</script>
